import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GithubSyncModalComponent } from './github-sync-modal/github-sync-modal.component';
import { GithubDomainModule, GITHUB_SYNC_DIALOG_TOKEN } from '@mode/github/domain';
import { GithubSyncDialogService } from './github-sync-dialog.service';
import { MatLegacyDialogModule } from '@angular/material/legacy-dialog';
import { SharedUiModule } from '@mode/shared/ui';
import { ButtonComponent } from '@mode/capra';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    ButtonComponent,
    CommonModule,
    MatLegacyDialogModule,
    SharedUiModule,
    ReactiveFormsModule,
    GithubDomainModule,
  ],
  declarations: [GithubSyncModalComponent],
  providers: [{ provide: GITHUB_SYNC_DIALOG_TOKEN, useClass: GithubSyncDialogService }],
})
export class GithubFeatureSyncModalModule {}
